var _excluded = ["variant"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from 'react';
import { TabletTabsStyled, BarTabsStyled, ContainerTabsStyled, BarPlanTabsStyled, ButtonTabsStyled } from './styles/TabsStyled';
;
var variantToComponent = {
  'tablet': TabletTabsStyled,
  'bar': BarTabsStyled,
  'container': ContainerTabsStyled,
  'bar-plan': BarPlanTabsStyled,
  'button': ButtonTabsStyled
};
var TabsList = function TabsList(_ref) {
  var variant = _ref.variant,
    props = _objectWithoutProperties(_ref, _excluded);
  var Component = variantToComponent[variant];
  return React.createElement(Component, props);
};
export default TabsList;